/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://r0p6lzmb27.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "apia1257807",
            "endpoint": "https://wiavzwedw4.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ceexmsl5abdm7mnu5cn6yzwrui.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:ba147349-3487-4333-9eb5-2f0671901534",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_pU3aZZjsp",
    "aws_user_pools_web_client_id": "29ssg3cqhddrivuk60li2c9bpv",
    "oauth": {
        "domain": "boatlink9255103e-9255103e-prod.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:8000/oauth/,https://www.theboatlink.com/oauth/,boatlink://oauth",
        "redirectSignOut": "http://localhost:8000/logout/,https://www.theboatlink.com/logout/,boatlink://logout",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "AMAZON",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_mobile_analytics_app_id": "9c97cce6e17e40fda8c01008f0e7c9a1",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "9c97cce6e17e40fda8c01008f0e7c9a1",
            "region": "us-east-1"
        }
    },
    "aws_user_files_s3_bucket": "boat-link-storage101545-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
